// images

import img0 from '../assets/images/N0.jpg';
import img1 from '../assets/images/N1.jpg';
import img2 from '../assets/images/N2.jpg';
import img3 from '../assets/images/N3.jpg';
import img4 from '../assets/images/N4.jpg';
//import img5 from '../assets/images/N5.jpg';
//import img6 from '../assets/images/N6.jpg';
import img7 from '../assets/images/N7.jpg';
import img8 from '../assets/images/N8.jpg';
import img9 from '../assets/images/N9.jpg';
import img10 from '../assets/images/N10.jpg';
import img11 from '../assets/images/N11.jpg';
import img12 from '../assets/images/N12.jpg';
import img13 from '../assets/images/N13.jpg';
import img14 from '../assets/images/N14.jpg';
import img15 from "../assets/images/N15.jpg";
import img16 from "../assets/images/N16.jpg";


/*****************************************
 * Examples constants and global variables
 *****************************************/

const data = {
  examples: [
    //////////////////// DORON
    [
      // Grpup 1
      //["A", "A*x", "1-(1-A)*x", "A*A", "A*(2-A)", "3A^2 - 2*A^3"],
      {
        headerText: "C=A",
        subHeaderText: [" C מבוססת על התמונה המקורית ללא שינויי תאורה "],
        step: 0.1,
        maxOpacity: 1, // 0+
        topOpacity: 1,
      },
      {
        headerText: "C=A*x",
        subHeaderText: [
          " מכהה את A בהתאם לערך x , שהוא סליידר שתוכלו לשנותו  בין 0 ל-1",
        ],
        step: 0.1,
        maxOpacity: 1, // 5+
      },

      {
        headerText: "Screen(A,x)",
        subHeaderText: [
          ["C=1-(1-A)*x"],
          [" מבהיר את A בהתאם לערך x , סליידר שתוכלו לשנותו  "],
        ],
        step: 0.1,
        maxOpacity: 1, // 1+
      },
      {
        headerText: "MULTIPLY(A,A)",
        subHeaderText: [["T=A*A"], ["C=A*(1-x)+T*x"]],
        step: 0.1,
        maxOpacity: 1, // 5+
      },
      {
        headerText: "Screen(A,A)",
        subHeaderText: [["T=A*(2-A)"], ["C=A*(1-x)+T*x"]],
        step: 0.1,
        maxOpacity: 1, // 1+
      },
      {
        headerText: "Soft-Light(A,A)",
        subHeaderText: [["T= 3A^2 - 2*A^3"], ["C=A*(1-x)+T*x"]],
        step: 0.1,
        maxOpacity: 1, // 1+
      },
    ],
  ],

  /*****************************************
   * Global variables
   *****************************************/

  topImages: [
    img0,
    img1,
    img2,
    img3,
    img4,
   // img5,
   // img6,
    img7,
    img8,
    img9,
    img10,
    img11,
    img12,
    img13,
    img14,
    img15,
    img16,
  ],
  bottomImages: [
    img0,
    img1,
    img2,
    img3,
    img4,
   // img5,
    //img6,
    img7,
    img8,
    img9,
    img10,
    img11,
    img12,
    img13,
    img14,
    img15,
    img16,
  ],

  exampleIdx: 0,
  groupIdx: 0,

  topImageIdx: 11,
  bottomImageIdx:11,

  size: {
    width: 900,
    height: 650,
  },
};

/*****************************************
 * UI constants
 *****************************************/

export const uiData = {
  // select example text
  groupOptions: [
    'ספיה',
   'מונוכרום',
   'רגיל'],

  selectOptions: [
    // ערםופ 1
    ['A', 'A*x', '1-(1-A)*x', 'A*A', 'A*(2-A)', '3A^2 - 2*A^3'],
    ['A', 'A*x', '1-(1-A)*x', 'A*A', 'A*(2-A)', '3A^2 - 2*A^3'],
    ['A', 'A*x', '1-(1-A)*x', 'A*A', 'A*(2-A)', '3A^2 - 2*A^3'],
    //  קבוצה21
  ],

  // clickable buttons with value
  // buttons: [
  //   {
  //     text: 'צעד אחד',
  //     value: 'step',
  //   },
  // ],

  // input with value
  bottomSlideNumber: {
    value: data.bottomImageIdx + 1,
    step: 1,
    min: 1,
    max: data.bottomImages.length - 1,
    label: '',
  },
  topSlideNumber: {
    value: data.topImageIdx + 1,
    step: 1,
    min: 1,
    max: data.topImages.length - 1,
    label: '',
  },

  // colors: ['#00426F', '#65C3A4', '#5765AE', '#59926E', '#453f78', '#30A3B0'],
};

export default data;
